<template>
  <div class="flex flex-col">
    <h2>Frecuencias</h2>

    <div v-if="!loading">
      <div v-if="paymentFrequencies" class="card mt-2">
        <h2>Frecuencias de Pago</h2>
        <table class="table-auto text-sm mt-4 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Semanas</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Descuento</th>
              <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Activo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="paymentFrequency in paymentFrequencies"
              :key="paymentFrequency.id"
              class="table-row"
            >
              <td class="table-cell">
                {{ paymentFrequency.name }}
              </td>
              <td class="table-cell">
                {{ paymentFrequency.weeks }}
              </td>
              <td class="table-cell">
                <discount
                  :paymentFrequency="paymentFrequency"
                  @discountUpdated="loadFrequencies()"
                />
              </td>
              <td class="table-cell">
                <custom-toggle
                  v-model="paymentFrequency.active"
                  @change="updatePaymentActive(paymentFrequency.id)"
                ></custom-toggle>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="deliveryFrequencies" class="card mt-6">
        <h2>Frecuencias de Entrega</h2>
        <table class="table-auto text-sm mt-4 bg-white">
          <thead class="text-left">
            <tr class="bg-primary-100">
              <th class="px-4 py-3 rounded-l-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Nombre</th>
              <th class="px-4 py-3 text-xs font-semibold text-primary-700 uppercase tracking-wide">Semanas</th>
              <th class="px-4 py-3 rounded-r-lg text-xs font-semibold text-primary-700 uppercase tracking-wide">Activo</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="deliveryFrequency in deliveryFrequencies"
              :key="deliveryFrequency.id"
              class="table-row"
            >
              <td class="table-cell">
                {{ deliveryFrequency.name }}
              </td>
              <td class="table-cell">
                {{ deliveryFrequency.weeks }}
              </td>
              <td class="table-cell">
                <custom-toggle
                  v-model="deliveryFrequency.active"
                  @change="updateDeliveryActive(deliveryFrequency.id)"
                ></custom-toggle>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div v-else class="flex w-full h-full items-center">
      <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
    </div>
  </div>
</template>

<script>
import CustomToggle from "@/components/ui/CustomToggle";
import Discount from "@/components/models/Discount";
import api from "@/api";
import { formatDatetime } from "@/utils/dateFormatter";
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Discounts",

  components: {
    CustomToggle,
    Discount,
  },

  data() {
    return {
      deliveryFrequencies: null,
      paymentFrequencies: null,
      loading: false,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "frequencies");

    this.loadFrequencies();
  },

  methods: {
    formatDatetime,

    integerToCurrency,

    async loadFrequencies() {
      this.loading = true;

      try {
        const response = await api.resources.getFrequencies();
        this.deliveryFrequencies = response.delivery_frequencies;
        this.paymentFrequencies = response.payment_frequencies;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async updatePaymentActive(id) {
      this.loading = true;

      try {
        const response = await api.plans.updatePaymentActive(id);
        this.$store.dispatch("successSnack", response.message);
        this.loadFrequencies();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    async updateDeliveryActive(id) {
      this.loading = true;

      try {
        const response = await api.plans.updateDeliveryActive(id);
        this.$store.dispatch("successSnack", response.message);
        this.loadFrequencies();
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },
  },
};
</script>